/* eslint-disable eqeqeq */
import {
  CmpTextFieldEnter,
  CmpButton,
} from "../../Component/Common/ToolBox/ToolBox";
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { fExecuteAPI } from "../../Server/Apis";
import { fAlertToast, GetGitterColumns } from "../../Utility/Utilitys";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./DoStamping.css";
import { moment } from "moment";
import ResultComponent from "./component/CmpDoStamp";

const GridcolumnsDOStamping = [
  {
    field: "A_VocTyp",
    headerName: "DocTyp",
    width: 150,
  },
  {
    field: "VocName",
    headerName: "DocName",
    width: 300,
  },
  {
    field: "A_VocDt",
    headerName: "VocDt",
    width: 300,
    hide: true,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "A_DO_RCVD_DT",
    headerName: "A_DO_RCVD_DT",
    width: 250,
    hide: true,
    valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
  },
  {
    field: "A_DO_RCVD_STATUS",
    headerName: "Status",
    width: 250,
  },
  {
    field: "B_RefDocNo",
    headerName: "B_RefDocNo",
    width: 100,
    hide: true,
  },
];
export default function DoStamping() {
  const InputFocusOnLoad = useRef(null);
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const vRdxuserInfo = useSelector((state) => state.login.value);
  // eslint-disable-next-line no-unused-vars
  const [sLoadObj, setLoadObj] = useState({
    code: "",
  });
  const [sError, setError] = useState("");
  const [sGridrows, setGridrows] = useState([]);
  const [sResult, setResult] = useState([
    // {
    //   vocTypCode: null,
    //   vocTypName: null,
    //   vocNo: null,
    //   partyName: null,
    // },
  ]);
  // eslint-disable-next-line no-unused-vars
  const [sEnterKeyObj, setEnterKeyObj] = useState({
    key: "Enter",
  });

  const fOnChangeInput = (e) => {
    setLoadObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));

    //IN MOBILE Backspace KEY NOT DETECTED TO CALL API WE USE BLUR
    if (
      e.target.value.length < sLoadObj.code.toString().length &&
      vMediaQuery &&
      e.target.name === "code"
    ) {
      var vBackspaceObj = {
        key: "Backspace",
      };
      if (e.target.value !== "" && vMediaQuery) {
        fOnKeyUp(vBackspaceObj);
      }
    }
  };
  const fOnKeyUp = async (e) => {
    setError("");
    setResult([]);
    if (e.key === "Enter") {
      if (sLoadObj.code == "") {
        setError("Document no should not be empty");
        // fAlertToast("FAILED", "Doc no should not be empty");
        return;
      } else {
        GetSummaryList(sLoadObj.code);
      }
    } else if (e.key === "Backspace") {
      setResult([]);
    }
  };

  // const fLoad = useCallback(
  //   async (e) => {
  //     if (sLoadObj.code != "") {
  //       GetSummaryList(sLoadObj.code);
  //     }
  //   },
  //   []
  // );

  const fClear = async (e) => {
    setError("");
    setLoadObj((obj) => ({
      ...obj,
      code: "",
    }));
    setResult([]);
  };

  //API BIN_ENQUIRY_GETROW
  const GetSummaryList = async (xcode) => {
    //xcode= WS001SISD010879
    let vSummaryListObj = {
      v_Scan: xcode,
      UserCd: vRdxuserInfo.UserID,
      // IPAddres: vRdxuserInfo.IP,
    };
    const vSummaryList = await fExecuteAPI(
      "LoadingReceipt_DoStamping_GETROW",
      vSummaryListObj
    );
    if (vSummaryList?.Type?.toUpperCase() == "SUCCESS") {
      setLoadObj((obj) => ({
        ...obj,
        code: "",
      }));
      setResult(vSummaryList?.ResultSet);
    } else if (vSummaryList?.response?.status == 500) {
      setLoadObj((obj) => ({
        ...obj,
        code: "",
      }));
      console.log(vSummaryList.response.data);
      setResult(vSummaryList.response.data.ResultSet);
    } else {
      setLoadObj((obj) => ({
        ...obj,
        code: "",
      }));
      console.log(vSummaryList.response.data);
      setResult(vSummaryList.response.data.ResultSet);
    }
  };

  useEffect(() => {
    InputFocusOnLoad.current?.focus();
  }, []);
  return (
    <div className="container-fluid my-3">
      <div className="Instant-picking-head">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "80vh",
          }}
        >
          <div className="w-100">
            <Grid
              container
              spacing={0}
              className="align-items-center "
              sx={{
                margin: "0 auto",
                // height: "80vh",
                // alignItems: "center",
                // display: "flex",
                justifyContent: "center",
              }}
            >
              <Grid item lg={4} md={4} xs={12}>
                <CmpTextFieldEnter
                  xref={InputFocusOnLoad}
                  xLabelText={"Documen No"}
                  xVariant={"outlined"}
                  xValue={sLoadObj.code}
                  xOnChange={(event) => fOnChangeInput(event)}
                  xReadOnly={false}
                  xType={"text"}
                  xName={"code"}
                  xOnKeyUp={(e) => {
                    fOnKeyUp(e);
                  }}
                  xOnEnter={(e) => {
                    fOnKeyUp(sEnterKeyObj);
                  }}
                  xSmShow={!!vMediaQuery}
                  xError={sError != ""}
                  xErrorMessage={sError}
                />
              </Grid>
              {/* <Grid item lg={4} md={4} xs={12}>
            <CmpButton
              xbtnName="Clear"
              xOnClick={fClear}
              xVariant="contained"
              xDisabled={false}
              xSize="small"
              xId={"IdClear"}
            />
          </Grid> */}
            </Grid>
            <Box>
              <ResultComponent data={sResult} />
            </Box>
          </div>
        </Box>
      </div>
    </div>
  );
}
